import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const s = {
  wrapper: styled.div`
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 11;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.75);
    padding: 14px;
  `,

  dialog: styled.div`
    max-width: 354px;
    color: #ffffff;
    max-height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  `,

  title: styled.div`
    font-size: 32px;
    font-weight: bold;
    line-height: 33px;
    text-align: center;
    margin-bottom: 16px;
  `,
};

function DefaultError() {
  return (
    <s.dialog>
      <s.title>An error has occurred</s.title>
    </s.dialog>
  );
}

class ErrorBoundary extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.error !== prevState.error || nextProps.info !== prevState.info) {
      return {
        error: nextProps.error,
        info: nextProps.info,
        fallback: false,
      };
    }

    return null;
  }

  static getErrorComponent(error, info) {
    return <UnknownError error={error} info={info} />;
  }

  constructor(props) {
    super(props);

    this.state = {
      error: props.error || null,
      info: null,
      fallback: true,
    };
  }

  componentDidCatch(error, info) {
    this.setState({
      error,
      info,
      fallback: true,
    });
  }

  render() {
    const { children, overlayMode, getErrorComponent } = this.props;
    const { error, info, fallback } = this.state;

    if (error) {
      const errorComponent = (
        <s.wrapper>
          {getErrorComponent ? getErrorComponent(error, info) : <DefaultError />}
        </s.wrapper>
      );

      if (fallback || !overlayMode) {
        return errorComponent;
      }

      return (
        <React.Fragment>
          {children}
          {errorComponent}
        </React.Fragment>
      );
    }

    return children;
  }
}
ErrorBoundary.propTypes = {
  error: PropTypes.object,
  info: PropTypes.object,
  children: PropTypes.any,
  overlayMode: PropTypes.bool,
  getErrorComponent: PropTypes.func,
};
ErrorBoundary.defaultProps = {
  overlayMode: false,
};

export { ErrorBoundary };
